<template>

    <div class="row justify-content-center mb-4 mx-auto px-0">

        <table style="width:100%;">
            <thead>
                <tr>
                    <th class="px-2" style="padding-bottom:15px!important; width:30%; vertical-align:middle;">
                      <input type="text"
                                style="font-size:11px; width:100%; border:1px solid #3A9AF3; border-radius:5px;"
                                
                                :placeholder="__('traductionview.searchclientname')"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                    <th class="px-2" style="padding-bottom:15px!important; width:30%; vertical-align:middle;">
                        <input type="text"
                                style="font-size:11px; width:100%; border:1px solid #3A9AF3; border-radius:5px;"
                                :placeholder="__('traductionview.search')"
                            
                                v-model="filterbeneficiary"
                                @change="onFilterBeneficiaryChange()">
                    </th>
                    <th class="px-2" style="padding-bottom:15px!important;  width:30%; vertical-align:middle;">
                       <input type="text"
                                style="font-size:11px; width:100%; border:1px solid #3A9AF3; border-radius:5px;"
                                
                                :placeholder="__('traductionview.searchstatus')"
                                v-model="filterstatus"
                                @change="onFilterStatusChange()">
                    </th>
                </tr>
            </thead>
        </table>

        <table class="dashboardstyle text-center abc-table mx-auto" style="width:100%; height: 600px; overflow: auto; display: block;">
            <thead class="abc-title-table">
                <tr style="border-bottom: 1px solid #3A9AF3;">
                    <th style="width:5%; vertical-align:middle; text-align:center;">id</th>
                    <th class="py-3 text-left" style="width:25%; vertical-align:middle;">Document
                        <button
                            style="text-align:center;"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri ascendant"
                            v-on:click="documentSortAsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                            </svg>
                        </button>
                        <button
                            style="text-align:center"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri descendant"
                            v-on:click="documentSortDsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                        </button>
                    </th>
                    <th style="width:15%; vertical-align:middle; text-align:left;">Project
                        <button
                            style="text-align:center;"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri ascendant"
                            v-on:click="projectSortAsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                            </svg>
                        </button>
                        <button
                            style="text-align:center"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri descendant"
                            v-on:click="projectSortDsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                        </button>
                    </th>
                    <th style="width:10%; vertical-align:middle;">
                        {{__("traductionpro.assigned")}}
                        <button
                            style="text-align:center;"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri ascendant"
                            v-on:click="staffSortAsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                            </svg>
                        </button>
                        <button
                            style="text-align:center"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri descendant"
                            v-on:click="staffSortDsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                        </button>
                    </th>
                    <th style="width:10%; vertical-align:middle;">
                        {{__("traductionpro.benif")}}
                        <button
                            style="text-align:center;"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri ascendant"
                            v-on:click="beneficiarySortAsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                            </svg>
                        </button>
                        <button
                            style="text-align:center"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri descendant"
                            v-on:click="beneficiarySortDsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                        </button>
                    </th>
                    <th style="width:10%; vertical-align:middle;">
                        {{__("traductionpro.entrepri")}}
                        <button
                            style="text-align:center;"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri ascendant"
                            v-on:click="companySortAsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                            </svg>
                        </button>
                        <button
                            style="text-align:center"
                            type="button"
                            class="btn-sort"
                            aria-label="Tri descendant"
                            v-on:click="companySortDsc">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                        </button>
                    </th>
                    <th style="width:10%; vertical-align:middle;">Status
                    </th>
                    <th style="width:10%; vertical-align:middle;">Submitted on
                    </th>
                    <th style="width:5%; vertical-align:middle;">Check</th>
                </tr>
            </thead>
            <tbody v-for="customer in customs" :key="customer.id" style="font-size: 11px; display:block; height: max-content; overflow:auto;">
                <tr v-for="(checklist, index) in customer.checklist_users" :key="index" style="border-bottom:solid rgb(206, 206, 206) 1px;">
                    <td style="vertical-align: middle; width:5%;" class="text-center">
                        {{ checklist.project.id }}
                    </td>
                    <td style="vertical-align: middle; width:25%; font-weight:bold; color:#3A9AF3;" class="py-3 text-left">
                            {{ checklist.checklist.requirement.name }}
                    </td>
                    <td style="vertical-align: middle; width:15%; text-align:left; color:#393636;">
                        {{ checklist.project.name }}
                    </td>
                    <td style="vertical-align: middle; width:10%;">
                        {{ checklist.project.staff_assigned.firstname }} {{ checklist.project.staff_assigned.lastname }}
                    </td>
                    <td style="vertical-align: middle; width:10%;">
                        {{ checklist.project.user.firstname }} {{ checklist.project.user.lastname }}
                    </td>
                    <td style="vertical-align: middle; width:10%; text-transform:capitalize;">
                        {{ checklist.project.client.company }}
                    </td>
                    <td style="vertical-align: middle; width:10%;">
                        <p class="mb-0" v-if="checklist.approved==0" style="color:#F18928; font-weight:bold;">To approve</p>
                        <p class="mb-0" v-else style="color:#17c231; font-weight:bold;">Approved</p>
                    </td>
                    <td class="text-center" style="vertical-align: middle; width:10%;">
                        <div v-for="(upload, index) in checklist.upload" :key="index" class="mx-auto">
                            <p class="mb-0">{{ upload.created_at | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</p>
                        </div>
                    </td>
                    <td style="vertical-align: middle; width:5%;">
                        <div v-for="(upload, index) in checklist.upload" :key="index" class="mx-auto">
                            <a class="justify-content-center"  :href="'/app/home/manager/documents/' + upload.filename" target="_blank" rel="noopener" role="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                            </svg></a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>

</template>

<script>
    import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
    import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
    Vue.use(VueFilterDateFormat);
    Vue.use(VueFilterDateParse);

    export default {
        props: [
            'clients',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                ups:[],
                filtername:"",
                filterbeneficiary:"",
                filterstatus:"",
            }
        },

        mounted() {
            this.clients.forEach(customer =>
            {
                this.customs.push(customer)

            });

        },


        methods: {
            onFilterNameChange(){
                this.customs=[];
                this.clients.forEach(customer =>
                {
                    var search = customer.firstname.concat(" ").concat(customer.lastname).toLowerCase()
                    if (search.includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });
            },

            onFilterBeneficiaryChange(){
                this.customs=[];
                this.clients.forEach(customer =>
                {
                    var customercopy = JSON.parse(JSON.stringify(customer));
                    customercopy.checklist_users=[];
                    customer.checklist_users.forEach(checklist_user =>
                    {
                        var search = checklist_user.project.user.firstname.concat(" ").concat(checklist_user.project.user.lastname).toLowerCase()
                        if (search.includes(this.filterbeneficiary.toLowerCase()))
                        {
                            customercopy.checklist_users.push(checklist_user);
                        }
                    });
                    this.customs.push(customercopy);
                });
            },

            onFilterStatusChange(){
                this.customs=[];
                this.clients.forEach(customer =>
                {
                    var customercopy = JSON.parse(JSON.stringify(customer));
                    customercopy.checklist_users=[];
                    customer.checklist_users.forEach(checklist_user =>
                    {
                        if (checklist_user.approved.toString().includes(this.filterstatus.toLowerCase()))
                        {
                            customercopy.checklist_users.push(checklist_user);
                        }
                    });
                    this.customs.push(customercopy);
                });
            },
            beneficiarySortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.project.user.firstname < b.project.user.firstname)
                    {
                        return -1;
                    }
                    else if (a.project.user.firstname > b.project.user.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            beneficiarySortDsc(){
                this.customs= this.customs.sort(function(a, b){
                    if (a.project.user.firstname > b.project.user.firstname)
                    {
                        return -1;
                    }
                    else if (a.project.user.firstname < b.project.user.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            companySortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.project.client.company < b.project.client.company)
                    {
                        return -1;
                    }
                    else if (a.project.client.company > b.project.client.company)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            companySortDsc(){
                this.customs = this.ccustoms.sort(function(a, b){
                    if (a.project.client.company > b.project.client.company)
                    {
                        return -1;
                    }
                    else if (a.project.client.company < b.progrproject.client.companyess)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            staffSortAsc(){
                this.ccustoms= this.customs.sort(function(a, b){
                    if (a.project.staff_assigned.firstname < b.project.staff_assigned.firstname)
                    {
                        return -1;
                    }
                    else if (a.project.staff_assigned.firstname > b.project.staff_assigned.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            staffSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.project.staff_assigned.firstname > b.project.staff_assigned.firstname)
                    {
                        return -1;
                    }
                    else if (a.project.staff_assigned.firstname < b.project.staff_assigned.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            documentSortAsc(){
                this.ccustoms= this.customs.sort(function(a, b){
                    if (a.checklist.requirement.name < b.checklist.requirement.name)
                    {
                        return -1;
                    }
                    else if (a.checklist.requirement.name > b.checklist.requirement.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            documentSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.checklist.requirement.name > b.checklist.requirement.name)
                    {
                        return -1;
                    }
                    else if (a.checklist.requirement.name < b.checklist.requirement.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            projectSortAsc(){
                this.ccustoms= this.customs.sort(function(a, b){
                    if (a.project.name < b.project.name)
                    {
                        return -1;
                    }
                    else if (a.project.name > b.project.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            projectSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.project.name > b.project.name)
                    {
                        return -1;
                    }
                    else if (a.project.name < b.project.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
        }
    }
</script>